export default {
  ["changeStatus"](state, status) {
    state.status = status;
  }
};
